var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.832,
    height: 38.916,
    viewBox: "0 0 31.832 38.916",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18010.285 19811.113)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18081 -19838)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.816,38.092a12.036,12.036,0,0,1-2.8-.865c-2.8-1.3-7.424-5.083-10.006-5.083S80.8,35.93,78.006,37.227a21.165,21.165,0,0,1-2.8.865,1.8,1.8,0,0,0-1.722,2.055A65.469,65.469,0,0,0,76.177,52.8c2.152,7.137,8.5,11.355,10.867,12.761a2.045,2.045,0,0,0,1.937,0C91.348,64.154,97.7,59.937,99.848,52.8a68.835,68.835,0,0,0,2.69-12.653A1.994,1.994,0,0,0,100.816,38.092Z",
    fill: "#84a2ff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.31,34.091a12.03,12.03,0,0,1-2.8-.865c-2.8-1.3-7.424-5.083-10.006-5.083S79.3,31.928,76.5,33.226a21.165,21.165,0,0,1-2.8.865,1.8,1.8,0,0,0-1.721,2.055A65.472,65.472,0,0,0,74.671,48.8c2.152,7.137,8.5,11.355,10.867,12.761a2.046,2.046,0,0,0,1.937,0c2.367-1.406,8.715-5.623,10.867-12.761a68.99,68.99,0,0,0,2.69-12.653A1.8,1.8,0,0,0,99.31,34.091Z",
    transform: "translate(-18081.055 -19836.27)",
    fill: "#cfae26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.05,29.874c-.215.108-.323.216-.538.324",
    transform: "translate(-18081 -19838)",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.265,49.123a4.532,4.532,0,0,1,.43-1.081,68.971,68.971,0,0,0,2.69-12.653,1.851,1.851,0,0,0-1.722-2.055,12.031,12.031,0,0,1-2.8-.865c-2.8-1.3-7.424-5.083-10.006-5.083a7.478,7.478,0,0,0-3.013.973",
    transform: "translate(-18081 -19838)",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.36,31.5c-.646.324-1.183.649-1.614.865a21.165,21.165,0,0,1-2.8.865,1.8,1.8,0,0,0-1.721,2.055,65.475,65.475,0,0,0,2.69,12.653c2.152,7.137,8.5,11.355,10.867,12.761a2.046,2.046,0,0,0,1.937,0A32.385,32.385,0,0,0,93.5,55.179",
    transform: "translate(-18081 -19838)",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.177,45.013c-.968-3.677-1.4-6.6-1.721-8.435a19.855,19.855,0,0,0,3.013-.973,4.353,4.353,0,0,0,.968-.541",
    transform: "translate(-18081 -19838)",
    fill: "none",
    stroke: "#ba9c21",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.943,44.148a7.022,7.022,0,0,1-.43,1.406,6.912,6.912,0,0,0-.215.757,15.456,15.456,0,0,1-.538,1.73,18.493,18.493,0,0,1-5.38,8.111A29.644,29.644,0,0,1,86.4,59.18a9.9,9.9,0,0,1-.861-.541,14.014,14.014,0,0,1-2.26-1.73",
    transform: "translate(-18081 -19838)",
    fill: "none",
    stroke: "#ba9c21",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.98,41.445V39.066a2.662,2.662,0,0,0-2.044-2.6,2.825,2.825,0,0,0-2.26.649,2.558,2.558,0,0,0-.753,1.73v2.487a5,5,0,0,0-1.614,1.73,7.205,7.205,0,0,0-.646,2.163A4.982,4.982,0,0,0,86.4,50.2a4.728,4.728,0,0,0,2.582-8.759Zm-1.829,4.65v1.3a.286.286,0,0,1-.323.324h-.538a.286.286,0,0,1-.323-.324V46.2a1.173,1.173,0,0,1-.538-1.3,1.317,1.317,0,0,1,.861-.973,1.2,1.2,0,0,1,1.4,1.189A1.292,1.292,0,0,1,87.151,46.095Zm.753-5.083a6.27,6.27,0,0,0-1.4-.216,5.378,5.378,0,0,0-1.291.216V39.066a1.056,1.056,0,0,1,.43-.973,1.484,1.484,0,0,1,1.506-.324,1.405,1.405,0,0,1,.861,1.3v1.946Z",
    transform: "translate(-18081 -19838)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.5ba4ac7788a183d7c0eae204937bfa7e.svg";
export { ForwardRef as ReactComponent };